import {Component} from '@angular/core';
import {FieldWrapper, FormlyModule} from '@ngx-formly/core';
import {CommonModule} from '@angular/common';
import {NzFormModule} from 'ng-zorro-antd/form';

@Component({
  selector: 'zorrly-wrapper-nz-form-field',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    NzFormModule,
  ],
  template: `
    <nz-form-item>
      <ng-container *ngIf="props.label && props.hideLabel !== true">
        <nz-form-label [nzRequired]="props.required && props.hideRequiredMarker !== true" [nzFor]="id">
          {{ props.label }}
        </nz-form-label>
      </ng-container>
      <nz-form-control [nzValidateStatus]="errorState" [nzErrorTip]="errorTpl">
        <ng-container #fieldComponent></ng-container>
        <ng-template #errorTpl let-control>
          <formly-validation-message [field]="field"></formly-validation-message>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  `
})
export class ZorrlyFormFieldWrapperComponent extends FieldWrapper {
  get errorState() {
    return this.showError ? 'error' : '';
  }
}
